import styled from 'styled-components'

/**
 * Container do bloco de switchers. Duas variantes:
 * - `flutuante`: card sobre o mapa, posicionado abaixo do card de infos.
 * - `sidebar`: seção dentro da sidebar de tela cheia, separada por borda.
 */
export const ContainerAlteracoesMalha = styled.div<{
  $variante: 'flutuante' | 'sidebar'
  $recolhido: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $recolhido }) => ($recolhido ? 'flex-start' : 'stretch')};
  gap: ${({ $recolhido }) => ($recolhido ? '0px' : '8px')};
  transition: gap 0.2s ease;

  ${({ $variante, $recolhido }) =>
    $variante === 'flutuante'
      ? `
        position: absolute;
        top: 80px;
        left: 15px;
        background-color: white;
        padding: ${$recolhido ? '8px' : '12px 15px'};
        border-radius: 8px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        z-index: 5;
        transition: padding 0.2s ease;
      `
      : `
        padding: 10px 15px;
        border-bottom: 1px solid #f0f0f0;
        flex-shrink: 0;
      `}
`

/**
 * Faixa clicável do topo: título + ícone. É um `button` para dar teclado e foco de
 * graça, com a aparência zerada porque visualmente é só o cabeçalho do bloco.
 *
 * Recolhido sobra apenas o ícone, então a faixa deixa de ocupar a largura toda — do
 * contrário o ícone ficaria solto à esquerda de um botão largo.
 */
export const HeaderAlteracoesMalha = styled.button<{ $recolhido: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  width: ${({ $recolhido }) => ($recolhido ? 'auto' : '100%')};
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  text-align: left;
`

/** Título do bloco de switchers, igual nos dois layouts. */
export const LabelAlteracoesMalha = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: #7b7b7b;
  margin: 0;
  padding: 0;
`

/**
 * Alvo do ícone de encolher/expandir. O próprio ícone já indica a ação (setas para
 * fora quando recolhido, para dentro quando aberto), por isso não há rotação aqui.
 */
export const BotaoRecolher = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 11px;
  color: var(--primary-color);
  cursor: pointer;

  &:hover {
    background: var(--hover-color);
  }
`

/**
 * Área dos switchers. Recolhe animando `max-height`/`opacity` em vez de `display: none`
 * para a transição existir; `visibility` tira o conteúdo do foco/leitor quando fechado.
 *
 * A largura também precisa zerar: o container flutuante é shrink-to-fit, e um filho de
 * altura 0 continua empurrando a largura dele: sem isto o card recolhido ficava largo
 * como o texto dos switchers em vez de ficar do tamanho do ícone.
 */
export const ConteudoAlteracoesMalha = styled.div<{ $recolhido: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;

  max-height: ${({ $recolhido }) => ($recolhido ? '0px' : '200px')};
  max-width: ${({ $recolhido }) => ($recolhido ? '0px' : 'none')};
  opacity: ${({ $recolhido }) => ($recolhido ? 0 : 1)};
  visibility: ${({ $recolhido }) => ($recolhido ? 'hidden' : 'visible')};
  transition: max-height 0.2s ease, opacity 0.2s ease, visibility 0.2s ease;
`
